import React, { Dispatch, SetStateAction, useState } from 'react';
import classNames from 'classnames';
import ErrorMessage from 'components/errorMessage';
import { Button } from 'components/ui/button';
import { Icon } from 'components/ui/icon';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';

interface IProps {
  inputValue: string;
  noteAreaOpen: boolean;
  setInputValue: Dispatch<SetStateAction<string>>;
  closeNoteArea: () => void;
  updateNote: () => void;
}

const Notes = ({
  inputValue,
  noteAreaOpen,
  setInputValue,
  closeNoteArea,
  updateNote,
}: IProps): JSX.Element => {
  const [confirmationModal, showConfirmationModal] = useState(false);
  const addNote = () => {
    showConfirmationModal(true);
  };
  const handleModal = (param: boolean) => {
    if (param) {
      updateNote();
    }
    showConfirmationModal(false);
  };

  return noteAreaOpen ? (
    <>
      <div className={classNames('pb-1 mb-4')}>
        <textarea
          id="notes"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className={classNames(
            'w-full h-[98px] bg-gray-blue-0 border border-gray-blue-20 rounded-md focus:outline focus:outline-1 focus:outline-green-400 focus:shadow-[0px_0px_0px_4px_#e6f5ee]',
            inputValue.length > 20 &&
              'outline-none shadow-none border border-red-400'
          )}
          rows={4}
          placeholder="Add a note..."
          required
        ></textarea>
        {inputValue.length > 20 && (
          <ErrorMessage
            isValidation
            className="mt-1"
            message="Maximum characters exceeded"
            preIcon={<Icon name="alert" size={16} className="dangerIcon" />}
          />
        )}
        <div className="flex justify-end mt-1">
          <Button
            size="sm"
            variant="ghost"
            className={classNames(
              'bg-gray-blue-0 text-gray-blue-80 border-none shadow-none hover:enabled:bg-gray-blue-3 hover:enabled:text-gray-blue-80 focus-visible:enabled:outline-green-400 focus-visible:enabled:outline focus-visible:enabled:outline-[3px] disabled:bg-gray-blue-2 disabled:text-gray-blue-20 mr-2'
            )}
            onClick={closeNoteArea}
          >
            Cancel
          </Button>
          <Button
            size="sm"
            disabled={inputValue.length === 0 || inputValue.length > 20}
            variant="secondary"
            onClick={addNote}
            className={'m-0'}
          >
            Add
          </Button>
        </div>
      </div>
      <Dialog
        open={confirmationModal}
        onOpenChange={(open) => {
          if (!open) showConfirmationModal(false);
        }}
      >
        <DialogContent
          className="max-w-5xl"
          onEscapeKeyDown={(e) => e.preventDefault()}
          onInteractOutside={(e) => e.preventDefault()}
        >
          <DialogHeader>
            <DialogTitle>Alert</DialogTitle>
          </DialogHeader>
          <div className="text-gray-blue-60 px-6 pt-6 pb-27 font-normal text-base leading-6">
            This will overwrite your existing note for this transaction. Are you
            sure you want to proceed?
          </div>
          <DialogFooter>
            <div>
              <Button
                variant="ghost"
                className={classNames(
                  'bg-gray-blue-0 text-gray-blue-80 border-none shadow-none hover:enabled:bg-gray-blue-3 hover:enabled:text-gray-blue-80 focus-visible:enabled:outline-green-400 focus-visible:enabled:outline focus-visible:enabled:outline-[3px] disabled:bg-gray-blue-2 disabled:text-gray-blue-20'
                )}
                onClick={() => handleModal(false)}
              >
                Cancel
              </Button>
              <Button size="sm" onClick={() => handleModal(true)}>
                Confirm
              </Button>
            </div>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  ) : (
    <></>
  );
};
export default Notes;
